import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { chatbotApi } from '../../../common/src';

const WidgetYesNo = (props) => {
  //console.log(props);
  const [categoryList, setCategoryList] = useState();
  const preText = props.childProps.state.prevMessage;

  const _itemClick = (message, intentName) => {
    const { loginId } = props;
    //console.log(message);
    if (message === '예') {
      if (loginId === undefined || loginId === null || loginId === '') {
        if (intentName === 'INT_SEARCH_CONTENT_DIRECT - yes') {
          props.childProps.actionProvider._yesNo_yesAnswer_parse(message);
        } else {
          props.childProps.actionProvider._yesNo_yesAnswer(message);
        }

        if (intentName === 'INT_MEMBER_SHOP_TERMINATION - yes') {
          setTimeout(() => {
            props.childProps.actionProvider._checkLogin(
              '로그인후 이용해 주세요.'
            );
          }, 700);
        }
      } else {
        props.childProps.actionProvider._yesNo(message);
      }
    } else {
      props.childProps.actionProvider._yesNo_noAnswer(message);
    }
  };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };
  const _prev = () => {
    //console.log(preText);
    props.childProps.actionProvider._categoryPrev(preText);
  };
  useEffect(() => {
    setCategoryList(props.childProps.payload.list);
  }, [props]);
  return (
    <>
      <div className="widget-container">
        {/* <div className="">
          <div className="widget-title">아래의 내용을 찾으셨나요?</div>
        </div> */}
        <div>
          <ul className="widget-content">
            {categoryList &&
              categoryList.map((item) => (
                <li
                  key={item.idx}
                  onClick={() =>
                    _itemClick(item.message, item.intentName, item.query)
                  }
                >
                  {item.message}
                </li>
              ))}

            <li onClick={_goHome}>
              <img src="/img/chatbot/icon_home.png" />
              처음으로
            </li>
          </ul>
        </div>
      </div>
      {/* <div className="widget-time">{props.childProps.payload.writetime}</div> */}
    </>
  );
};
export default shopContext(withRouter(WidgetYesNo));
